import { z } from "zod";

/**
 * Recording Schema (Isomorphic - camelCase)
 * Represents audio/video recordings of calls
 */
export const RecordingSchema = z.object({
  id: z.string().uuid(),
  callAttemptId: z.string().uuid(),

  // Stockage
  storagePath: z.string(),
  storageProvider: z.string().default("supabase"),

  // Métadonnées fichier
  format: z.string().nullable(),
  durationMs: z.number().int().nullable(),
  sizeBytes: z.number().int().nullable(),

  // URLs (signées temporairement)
  publicUrl: z.string().nullable(),
  expiresAt: z.date().nullable(),

  // Métadonnées
  metadata: z.record(z.string(), z.unknown()).default({}),

  createdAt: z.date(),
  updatedAt: z.date(),
});

export type Recording = z.infer<typeof RecordingSchema>;
